import React, { Component } from 'react';
import { connect } from 'react-redux';
import {setShowMeetingState, showCommitteeMeetings, hideCommitteeMeetings } from '../actions/index';

class showMeetings extends Component{


	getMeetings(ccode){
		if(ccode){
			this.props.showCommitteeMeetings(ccode);
		}
	}

	hideMeetings(ccode){
		if(ccode){
			this.props.hideCommitteeMeetings(ccode);
		}
	}


	getUpcomingMeeting(committeeMeeting){
		if(typeof committeeMeeting.upcoming_meeting === 'undefined'){
			return (<div className="no-meetings"> No Upcoming Meeting</div>);
		} else{
			return (<div className="committee-meetings"><strong>Next Meeting: </strong>{committeeMeeting.upcoming_meeting.nice_date}</div>);
		}
	}

	getPastMeeting(committeeMeeting){
		if(typeof committeeMeeting.past_meeting === 'undefined'){
			return (<div className={'no-meetings'}>No Previous Meeting</div>);
		} else{
			return (<div className="committee-meetings"><strong>Last Meeting: </strong>{committeeMeeting.past_meeting.nice_date}</div>);
		}
	}

	getHtml(){

		const ccode = this.props.ccode;
		let committeeMeetings = this.props.committeeMeetings[ccode];
		if(typeof committeeMeetings === 'undefined' || committeeMeetings.length === 0 ){
				return (<div className="show-meetings-dropdown">
					<div className="no-meetings"> No Upcoming Meeting</div>
					<div className="no-meetings"> No Previous Meeting</div>
				</div>);
		} else{
			return (<div className={'show-meetings-dropdown'}>
				{this.getUpcomingMeeting(committeeMeetings)}
				{this.getPastMeeting(committeeMeetings)}
			</div>)
		}

	}


	render(){
		if(this.props.myCommittees.includes(this.props.ccode)){
			let showMeetings = this.getHtml();
			return (showMeetings);
		} else{
			return null;
		}

	}

}

function mapStateToProps( { myCommittees, requestedCommittees, showMeetings, committeeMeetings } ) {
	return {
		myCommittees,requestedCommittees,showMeetings, committeeMeetings
	};
}

export default connect( mapStateToProps, {setShowMeetingState, showCommitteeMeetings, hideCommitteeMeetings } )( showMeetings );